import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { useToggleIncrementalDeploysProductionEnabledMutation } from "../queries.generated"
import {
  SiteDetailsIncrementalDeploysProductionEnabledFieldsFragment,
  SiteDetailsIncrementalDeploysProductionEnabledFieldsFragmentDoc,
} from "../fragments.generated"

export function useToggleIncrementalDeploysProduction(siteId: string) {
  const [
    toggleIncrementalDeploysEnabledMutation,
    { loading },
  ] = useToggleIncrementalDeploysProductionEnabledMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleIncrementalDeploysProduction = () => {
    setError(null)
    return toggleIncrementalDeploysEnabledMutation({
      variables: {
        siteId,
      },
      update: (proxy, { data }) => {
        if (!data?.toggleIncrementalDeploysProductionEnabled?.success) {
          return
        }

        const fragmentInfo = {
          id: `Site:${siteId}`,
          fragment: SiteDetailsIncrementalDeploysProductionEnabledFieldsFragmentDoc,
        }

        const site = proxy.readFragment<
          SiteDetailsIncrementalDeploysProductionEnabledFieldsFragment
        >(fragmentInfo)

        if (!site) {
          return
        }

        site.incrementalDeploysProductionEnabled = !site.incrementalDeploysProductionEnabled

        proxy.writeFragment<
          SiteDetailsIncrementalDeploysProductionEnabledFieldsFragment
        >({
          ...fragmentInfo,
          data: site,
        })
      },
      optimisticResponse: {
        toggleIncrementalDeploysProductionEnabled: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleIncrementalDeploysProduction, { loading, errorAlert }] as const
}
